import React, { useState } from 'react';
import { useHistory } from "react-router-dom";
import { useSelector } from 'react-redux';
import MyImageCard from './MyImageCard';
import LoadingSpinner from '../LoadingSpinner';


export default function MyGallery() {

    const {token, user} = useSelector(state => state.auth);
    const history = useHistory();
    const [userImages, setUserImages] = useState([]);
    const [fetched, setFetched] = useState(false);
      
    if(!localStorage.getItem("token")){
        history.push("/login")
    }
    
    // NATIVE FIX: Resolve the true, authentic token generated by the Ruby backend handshake
    const activeToken = token && token !== 'wordpress_session' ? token : localStorage.getItem("token");
    
    if(activeToken && !fetched){
        fetch(`https://test-api.stainedglassusa.com/user_images`,
        {
            headers: {
            'Access-Control-Allow-Origin':'*',
            'Access-Control-Allow-Methods': 'OPTIONS,POST,GET',
            'Authorization': `bearer ${activeToken}`}
        })
        .then(r => r.json())
        .then(data => {
            // DEFENSIVE CHECK: Only set the array if the backend authorized and returned valid rows
            if (Array.isArray(data)) {
                setUserImages(data);
                setFetched(true);
            } else {
                console.error("Ruby API rejected token or returned non-array error object:", data);
                // Clear out fetched so it doesn't try to loop over an error object layout
                setFetched(true);
                setUserImages([]); 
            }
        })
        .catch(err => {
            console.error("Network interface failure:", err);
            setFetched(true);
            setUserImages([]);
        });
    } 
    
    return (
        <div>
            {user && <h1>{user.username}'s Gallery</h1>}
            {!fetched ? <LoadingSpinner /> : 
                userImages.length === 0 ? 
                history.push('/images')
                 :
                    <div id="my-gallery">
                        {userImages.map(userImageObj => <MyImageCard id="my-image-card" key={userImageObj.id} userImage={userImageObj}  />)}
                    </div>
                }
        </div>
    );
    
}